var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hand-left_svg__hand-left",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 692.87 488.65"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hand-left_svg__cls-1{fill:#ffbfbf}.hand-left_svg__cls-2,.hand-left_svg__cls-4{fill:none;stroke-miterlimit:10;stroke-width:3.13px;stroke:#1d1d1b}.hand-left_svg__cls-4{stroke-linecap:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hand-left_svg__hand-left-2",
    "data-name": "hand-left"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M798.92 960.54l7.06-3.65s6.54-5.92 26-6.92c0 0 14.69-9.13 25.31-5.72s1.79 23.85-7.53 27.67a101.16 101.16 0 01-13.7 4.81",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-2",
    d: "M798.92 960.54l7.06-3.65s6.54-5.92 26-6.92c0 0 14.69-9.13 25.31-5.72s1.79 23.85-7.53 27.67a101.16 101.16 0 01-13.7 4.81",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M703 1027.07l30.65-44.34 83.7 4.93s-12.37 5.7-33.41 21.1c-23.78 17.41-53.83 76.35-53.83 76.35z",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.29 85.64l30.65-44.34 83.7 4.93s-12.37 5.7-33.41 21.1c-23.78 17.41-53.83 76.35-53.83 76.35z",
    stroke: "#00fcac",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 3.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M700.87 1031.26s13.17-28.35 19.73-36.2c0 0 3.42-6.06 5.09-10.14s5.79-8.71 18.16-11.17",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-2",
    d: "M700.87 1031.26s13.17-28.35 19.73-36.2c0 0 3.42-6.06 5.09-10.14s5.79-8.71 18.16-11.17",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M780.8 959.12s7.66-2.42 26.59 4.23c0 0 21.87 2.23 25.78 6.47s5.32 16.22-3.14 19.5-21.19 5.14-41.6-.83c0 0-8.54 8.76-26.4 15.54",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-2",
    d: "M780.8 959.12s7.66-2.42 26.59 4.23c0 0 21.87 2.23 25.78 6.47s5.32 16.22-3.14 19.5-21.19 5.14-41.6-.83c0 0-8.54 8.76-26.4 15.54",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M784.39 1007.19s20.67 5.57 29.25 5.68 18 3.79 18 3.79 10.51 7.19 12.72 11.13c0 0 16.93 10.86 18.4 17.36s-9.11 10.61-9.11 10.61a33.13 33.13 0 01-32-13.6l-3.18-.62s-6.77 5-24.06 2.71l-2.26.82s-2.18 15.65-21.89 23.47a.43.43 0 00-.24.57.25.25 0 000 .07c.86 1.24 1.39 6.1-14.48 23.67a29.89 29.89 0 012.65 9.18c.6 5.19 4.26 26 14.12 30.88 6.36 3.12 13.73-1.86 28.34-4.2 6-1 15.63-3.47 15.63-3.47s7.69-10.27 26-17.8c7.14-3 12.94-2.86 17.38-1.64a14.39 14.39 0 0110.17 15.88c-.85 6.08-8.14 13.86-13.41 18.88-3.94 3.74-7.2 7.19-9.79 10.1a41.81 41.81 0 01-15.9 11.06 120.88 120.88 0 01-24.67 6.5c-16 2.43-52.82 31.14-62.54 38.8-22.17 17.47-53.29 25.74-66 29.79-16.12 5.19-320.16 137.19-440.3 189.61a26 26 0 01-28.68-5.62c-23.2-22.94-42.53-105.38-14-162.84a40.64 40.64 0 0135.53-22.8c54-1.15 272.46-30.86 335.26-48.47 0 0 47.11-9 61.56-43.47s57.76-88 57.76-88 18.46-29 24.19-33.2a31.07 31.07 0 008.71-10.64L734 988s13.07-20.86 25.46-30l9.45-14.88s8.68 1.5 9.55 5.35 11.11 7.3-13.54 45.81c0 0-2.75 17.37-18.4 34.2a69 69 0 01-17.52 33.44",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-4",
    d: "M784.39 1007.19s20.67 5.57 29.25 5.68 18 3.79 18 3.79 10.51 7.19 12.72 11.13c0 0 16.93 10.86 18.4 17.36s-9.11 10.61-9.11 10.61a33.13 33.13 0 01-32-13.6l-3.18-.62s-6.77 5-24.06 2.71l-2.26.82s-2.18 15.65-21.89 23.47a.43.43 0 00-.24.57.25.25 0 000 .07c.86 1.24 1.39 6.1-14.48 23.67a29.89 29.89 0 012.65 9.18c.6 5.19 4.26 26 14.12 30.88 6.36 3.12 13.73-1.86 28.34-4.2 6-1 15.63-3.47 15.63-3.47s7.69-10.27 26-17.8c7.14-3 12.94-2.86 17.38-1.64a14.39 14.39 0 0110.17 15.88c-.85 6.08-8.14 13.86-13.41 18.88-3.94 3.74-7.2 7.19-9.79 10.1a41.81 41.81 0 01-15.9 11.06 120.88 120.88 0 01-24.67 6.5c-16 2.43-52.82 31.14-62.54 38.8-22.17 17.47-53.29 25.74-66 29.79-16.12 5.19-320.16 137.19-440.3 189.61a26 26 0 01-28.68-5.62c-23.2-22.94-42.53-105.38-14-162.84a40.64 40.64 0 0135.53-22.8c54-1.15 272.46-30.86 335.26-48.47 0 0 47.11-9 61.56-43.47s57.76-88 57.76-88 18.46-29 24.19-33.2a31.07 31.07 0 008.71-10.64L734 988s13.07-20.86 25.46-30l9.45-14.88s8.68 1.5 9.55 5.35 11.11 7.3-13.54 45.81c0 0-2.75 17.37-18.4 34.2a69 69 0 01-17.52 33.44",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-4",
    d: "M737 1051.16a36.64 36.64 0 012.27 9.41c1.15 9.64-.14 25.27-15.28 40.13a68.27 68.27 0 00-19.12 34.3 123.77 123.77 0 00-1.77 39.3",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M844.42 1027.74s-4.81 3.52 3.31 11.58l6.95 7s6.19-2.81 8-1.2",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-2",
    d: "M844.42 1027.74s-4.81 3.52 3.31 11.58l6.95 7s6.19-2.81 8-1.2",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M807.49 963.3a16.33 16.33 0 009.19 4.79c5.92 1 12 5.2 12 5.2s1.84-3.09 4.59-3.53",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-2",
    d: "M807.49 963.3a16.33 16.33 0 009.19 4.79c5.92 1 12 5.2 12 5.2s1.84-3.09 4.59-3.53",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M832.08 949.87s1.39 5.22 19.59.44c0 0 4-1 5.63-6.14",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-2",
    d: "M832.08 949.87s1.39 5.22 19.59.44c0 0 4-1 5.63-6.14",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M760.55 957.42s8.93-4 13.66-12",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-2",
    d: "M760.55 957.42s8.93-4 13.66-12",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M816.49 1125.43s6.93-3.55 12.76 13.25",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-4",
    d: "M816.49 1125.43s6.93-3.55 12.76 13.25",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M765.37 1191.4s5.56-9.56 3.85-33",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-4",
    d: "M765.37 1191.4s5.56-9.56 3.85-33M808.29 992.19s-17.83 12.58-26.69 17c0 0-3.19 17.8-25.29 34.76 0 0-1 8.77 8.23 19",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M823.87 1140.75s1.59 5.81 6.14 7.72",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-4",
    d: "M823.87 1140.75s1.59 5.81 6.14 7.72",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M772.41 1132.85s-.61 6.38 4.54 14.56",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-4",
    d: "M772.41 1132.85s-.61 6.38 4.54 14.56",
    transform: "translate(-178.71 -941.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-left_svg__cls-1",
    d: "M779.87 1008.64s.15 1.57-1.49 5.27-14.59 15.15-14.59 15.15l-1.14-4.19z",
    transform: "translate(-178.71 -941.43)"
  }))));
}
export default __webpack_public_path__ + "c574d6cc9012a3ac8d2b59f5ec927405.svg";
export { SvgHandLeft as ReactComponent };